interface ErrorLocationProps {
  filename?: string;
  lineno?: number;
  colno?: number;
}

export function ErrorLocation({
  filename = "unknown",
  lineno = 1,
  colno = 1,
}: ErrorLocationProps) {
  return (
    <div className="bg-secondary-0 text-white p-2 font-mono text-2xs border-t-0 border-x border-secondary-300">
      <div className="flex items-center gap-1 overflow-x-auto whitespace-nowrap leading-[1.5]">
        <span className="text-secondary-n-50">at</span>
        <span className="text-blue-400">{filename}</span>
        <span className="text-secondary-n-50">
          :{lineno}:{colno}
        </span>
      </div>
    </div>
  );
}

export default ErrorLocation;
